import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Divider} from '../../../../../../../../../commons/components/divider'
import {useCurrencyFormatter} from '../../../../../../../../../commons/hooks/currency'
import {getPlaceInfoFromTicket} from '../../../../../../selectors/order-success'
import c from '../../../../../classnames.scss'
import {LabelWithValue} from '../../../../../common/label-with-value'
import {PlaceInfoProps} from './interfaces'
import s from './place-info.scss'

export const PlaceInfo = ({ticket}: PlaceInfoProps) => {
  const {t} = useTranslation()
  const placeInfoClassNames = classNames(c.formLabelsColor, c.textFont)
  const {area, table} = getPlaceInfoFromTicket(ticket)
  const {getTicketPriceText} = useCurrencyFormatter()

  return (
    <>
      <div className={s.container}>
        <div className={s.placeInfoContainer}>
          <LabelWithValue
            label={t('seatings_sector')}
            value={ticket?.ticketDetails?.sectorName}
            valueClassName={placeInfoClassNames}
            labelClassName={placeInfoClassNames}
          />
          {area ? (
            <LabelWithValue
              label={t('seatings_area')}
              value={area}
              valueClassName={placeInfoClassNames}
              labelClassName={placeInfoClassNames}
            />
          ) : (
            <>
              <LabelWithValue
                label={table ? t('seatings_table') : t('seatings_row')}
                value={table || ticket?.ticketDetails?.rowNumber}
                valueClassName={placeInfoClassNames}
                labelClassName={placeInfoClassNames}
              />
              <LabelWithValue
                label={t('seatings_seat')}
                value={ticket.ticketDetails.seatNumber}
                valueClassName={placeInfoClassNames}
                labelClassName={placeInfoClassNames}
              />
            </>
          )}
        </div>
        <div className={s.ticketInfoContainer}>
          {ticket.ticketDetails?.pricingOptionName ? (
            <div className={s.ticketNameContainer}>
              <div className={s.priceOptionTicketName}>{ticket.name}</div>
              <div>{ticket.ticketDetails?.pricingOptionName}</div>
            </div>
          ) : (
            <div>{ticket.name}</div>
          )}
          <div>{getTicketPriceText(ticket.price)}</div>
        </div>
      </div>
      <Divider />
    </>
  )
}
